import { Button, Flex } from '@chakra-ui/react';
import { Icon } from '@common/components/Icon';
import { Image } from '@common/components/Image';
import React, { useState } from 'react';
import { TextBlock } from 'src/apps/invest/common/components/TextBlock';
import { UI } from 'src/apps/invest/common/shells/UI';
import { usePropertiesDashboardViewModel } from '../../models/PropertyDashboardViewModel';

export const JoinTheWaitlist: React.FC = () => {
  const viewModel = usePropertiesDashboardViewModel();
  const [processing, setProcessing] = useState(false);

  const joinWaitingList = async () => {
    setProcessing(true);
    const status = await viewModel.joinWaitlist();
    if (status.success) {
      window.location.reload();
    } else {
      alert(status.error);
      setProcessing(false);
    }
  };

  return (
    <UI containerPadding={0}>
      <Flex flex={1} justifyContent="center">
        <Flex
          p={['10px', '10px', '0px']}
          maxWidth={['100%', '100%', '1000px', '1440px']}
          w={'100%'}
          backgroundSize={['cover', 'cover', 'cover', 'cover', '100%']}
          backgroundRepeat={'no-repeat'}
          flex={1}
          backgroundPosition={['center', 'center', 'bottom']}
          backgroundImage={[
            '/assets/gfx/blurred-properties-mobile.png',
            '/assets/gfx/blurred-properties-mobile.png',
            '/assets/gfx/blurred-properties.png',
          ]}>
          <Flex
            flexDirection={'column'}
            w={'100%'}
            maxW={'500px'}
            m={' 0 auto'}
            padding={['20px', '0']}
            alignItems="center">
            <Image h={'145px'} w={'145px'} image="residental-home"></Image>
            <TextBlock textAlign="center" weight="bold" fontSize="36px">
              Join the Priority Access List
            </TextBlock>
            <TextBlock maxW={'350px'} textAlign="center">
              Buy fractions of investment homes starting at $100, and let us manage the headaches for you.
            </TextBlock>
            <Button
              isLoading={processing}
              onClick={() => joinWaitingList()}
              mt={'24px'}
              maxW={'350px'}
              w={'100%'}
              rightIcon={<Icon icon="arrow-right-long" />}>
              Grab my spot
            </Button>
          </Flex>
        </Flex>
      </Flex>
    </UI>
  );
};
